import { render, staticRenderFns } from "./BecomeHost.vue?vue&type=template&id=9947e930&"
import script from "./BecomeHost.vue?vue&type=script&lang=js&"
export * from "./BecomeHost.vue?vue&type=script&lang=js&"
import style0 from "./BecomeHost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports